import React from 'react'
import {request} from '../../helpers/request.js';
import {Fade} from 'react-bootstrap'
import PaymentHistoryComponent from './PaymentHistoryComponent'
import PaymentComponent from './PaymentComponent'
import {formatMoney} from '../../helpers/formatMoney'
import StaticTextComponent from './StaticTextComponent'
import paymentProvider from './PaymentSelector';
import FieldComponent from './FieldComponent'
import {t} from '../../helpers/translate'
let config = require('config');

class PremiumUpdateComponent extends React.Component {

  constructor(props) {
    super(props);
  }

  determineProvider(){
    const paymentHistoryData = this.props.paymentHistoryData;

    if(paymentHistoryData && paymentHistoryData.payments 
      && Array.isArray(paymentHistoryData.payments) 
      && paymentHistoryData.payments.length > 0)
    {
      const provider = paymentHistoryData.payments[paymentHistoryData.payments.length - 1].payment_provider;

      if(provider){
        return provider;
      }
    }
    return this.props.defaultProvider;
  }

  isUserAgent(){
    return sessionStorage.getItem('auth_level') == 'agent';
  }

  render() {
    const paymentHistoryData = this.props.paymentHistoryData;
    const inProcess = this.props.processingFailedPayments || this.props.updatingCard;

    const applicationData = this.props.applicationData;
    const recurringPayments = applicationData.status == 'sold' && applicationData.additional_data.payment_option == 'monthly';

    return (
      <div>
        {
          this.props.quoteResponseData &&
          <div className="row">
            <div className="col-md-4">
              <Fade in={this.props.quoteResponseData !== null && this.props.quoteResponseData.premium_difference !== 0}>
                <div className="form-group">
                  <label className="text-uppercase">{t(this.props.quoteResponseData.premium_difference < 0 ? 'Total Refund' : 'Additional Premiums')}</label>
                  <StaticTextComponent value={formatMoney(this.props.quoteResponseData.premium_difference, this.props.quoteResponseData.currency)}/>
                </div>
              </Fade>
            </div>
          </div>
        }
        <div className="row">
          <div className="col-md-12">
          { (() => {
              if (!this.props.quoteResponseData || this.props.quoteResponseData.type == 'charge' || this.props.quoteResponseData.premium_difference == 0) {
                return <div>
                  <label className="text-uppercase">{t('Payment History')}</label>
                  <PaymentHistoryComponent 
                    provider={this.determineProvider()} 
                    data={paymentHistoryData}
                    setPaymentsToBeProcessed={this.props.setPaymentsToBeProcessed}
                    loadData={this.props.loadData}
                    processFailedPayments={this.props.processFailedPayments}
                    applicationId={this.props.applicationId}
                    applicationData={this.props.applicationData}
                    setCancellationFee={this.props.setCancellationFee}
                    refundPolicyIssueFee={this.props.refundPolicyIssueFee}
                    refundCancellationFee={this.props.refundCancellationFee}
                    refundTransactionFee={this.props.refundTransactionFee}
                    showModal={this.props.showConfirmationModal}
                    showConfirmationModal={this.props.showConfirmationModal}
                    editMode={this.props.editMode}
                    addPaymentToBeProcessed={this.props.addPaymentToBeProcessed}
                    paymentsToProcess={this.props.paymentsToProcess}
                    />
                </div>
              }
            })()
          }          
          {
            this.props.quoteResponseData && 
            <div className="row">
              <div className="col-md-4">
                <Fade in={this.props.quoteResponseData !== null && this.props.quoteResponseData.premium_difference !== 0}>
                  <div className="form-group">
                    <label className="text-uppercase">{t(this.props.quoteResponseData.premium_difference < 0 ? 'Total Refund' : 'Additional Premiums')}</label>
                    <StaticTextComponent value={formatMoney(this.props.quoteResponseData.premium_difference, this.props.quoteResponseData.currency)}/>
                  </div>
                </Fade>
              </div>
            </div>
          }
          {!this.props.editMode && !inProcess && recurringPayments && this.props.applicationData.status == 'sold' ?
            <button 
              disabled={this.props.processingFailedPayments}
              className="btn button-secondary"
              onClick={this.props.toggleUpdatingCard}
            >{t('Update Credit Card')}</button>
            :
            null
          }

          {!this.props.editMode && !inProcess && (this.props.paymentsToProcess.length == 1) ?
            <button 
              className="btn button-secondary"
              onClick={this.props.toggleProcessingFailedPayments}
            >{t('Process Payment')}</button>
            :
            null
          }
          
          { (() => {
            if (this.props.editMode && this.props.quoteResponseData && this.props.quoteResponseData.premium_difference < 0) {
              let provider = this.determineProvider();
              const Module = paymentProvider[provider]['refund'];
              return <Module provider={provider} {...this.props} />;
            }
          })()
          }
          
          {
            inProcess || (this.props.editMode && this.props.quoteResponseData && this.props.quoteResponseData.premium_difference > 0) ?
            <PaymentComponent provider={this.determineProvider()} {...this.props}/> : null
          }
          </div>
        </div>
      </div>);
  }
}

PremiumUpdateComponent.displayName = 'PremiumUpdateComponent';
export default PremiumUpdateComponent;



// WEBPACK FOOTER //
// ./src/components/common/PremiumUpdateComponent.js